/*
 * Highlight all occurrences of the term from ?highlightText=... by wrapping
 * matches in <mark>, which uses the browser default highlight color.
 *
 * Notes:
 * - Case-insensitive match for better UX
 * - Skips script/style/noscript/textarea, inputs, content already in <mark>
 * - Removes any text fragment (#:~:text=...) from the URL to avoid native jump
 */

function escapeRegExp(value) {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function removeTextFragmentFromUrl() {
  if (typeof window === 'undefined') return;
  if (!window.location.hash) return;
  if (!window.location.hash.includes(':~:text=')) return;
  try {
    const newUrl = window.location.pathname + window.location.search;
    window.history.replaceState(null, '', newUrl);
  } catch (_) {
    // no-op
  }
}

function shouldSkipNode(node) {
  if (!node || !node.parentNode) return true;
  const parent = node.parentNode;
  if (parent.nodeType !== 1) return false; // non-element parent is fine

  const tagName = parent.tagName ? parent.tagName.toLowerCase() : '';
  if (
    tagName === 'script' ||
    tagName === 'style' ||
    tagName === 'noscript' ||
    tagName === 'textarea'
  ) {
    return true;
  }
  if (tagName === 'input' || tagName === 'select' || tagName === 'option') {
    return true;
  }
  // Do not re-highlight inside an existing <mark>
  if (tagName === 'mark') {
    return true;
  }
  // Skip within elements that are hidden from layout/accessibility
  const ariaHidden = parent.getAttribute && parent.getAttribute('aria-hidden');
  if (ariaHidden === 'true') return true;

  return false;
}

function highlightOccurrences(root, term) {
  if (!root || !term) return 0;
  const pattern = new RegExp(escapeRegExp(term), 'gi');
  let totalMatches = 0;

  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
    acceptNode(node) {
      if (!node.nodeValue || !node.nodeValue.trim())
        return NodeFilter.FILTER_REJECT;
      if (shouldSkipNode(node)) return NodeFilter.FILTER_REJECT;
      return NodeFilter.FILTER_ACCEPT;
    },
  });

  const nodesToProcess = [];
  while (walker.nextNode()) {
    nodesToProcess.push(walker.currentNode);
  }

  nodesToProcess.forEach(textNode => {
    const text = textNode.nodeValue;
    if (!pattern.test(text)) {
      pattern.lastIndex = 0; // reset for next node
      return;
    }
    pattern.lastIndex = 0; // reset before replace operations

    const fragment = document.createDocumentFragment();
    let lastIndex = 0;
    for (
      let match = pattern.exec(text);
      match !== null;
      match = pattern.exec(text)
    ) {
      const matchStart = match.index;
      const matchEnd = match.index + match[0].length;

      if (matchStart > lastIndex) {
        fragment.appendChild(
          document.createTextNode(text.slice(lastIndex, matchStart)),
        );
      }

      const mark = document.createElement('mark');
      mark.textContent = text.slice(matchStart, matchEnd);
      fragment.appendChild(mark);
      totalMatches += 1;

      lastIndex = matchEnd;
    }

    if (lastIndex < text.length) {
      fragment.appendChild(document.createTextNode(text.slice(lastIndex)));
    }

    textNode.parentNode.replaceChild(fragment, textNode);
  });

  return totalMatches;
}

function getHighlightTermFromUrl() {
  try {
    const params = new URLSearchParams(window.location.search);
    const value = params.get('highlightText');
    if (!value) return '';
    return value.trim();
  } catch (_) {
    return '';
  }
}

function initHighlightText() {
  removeTextFragmentFromUrl();
  const term = getHighlightTermFromUrl();
  if (!term) return;
  highlightOccurrences(document.body, term);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHighlightText, {
    once: true,
  });
} else {
  initHighlightText();
}
